import { Deserializable } from '@models/deserializable';
import { deserialize, serializable } from 'serializr';

export class QTestModule implements Deserializable {
  @serializable
  public id: string;
  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(QTestModule, input));
  }
}
